// extracted by mini-css-extract-plugin
export var fullHeightState = "_1f-7";
export var headerCell = "_1f-1";
export var loadingStateCell = "_1f-4";
export var rowWrapper = "_1f-3";
export var standaloneTable = "_1f-8";
export var standaloneTableWithBodyFill = "_1f-9";
export var stateCell = "_1f-5";
export var table = "_1f-0";
export var tableBodyFiller = "_1f-6";
export var white = "_1f-2";